import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Provider } from '@supabase/supabase-js';
import { supabase } from '../api';

type ProviderProps = {
  options?: any;
  provider: Provider;
};

type HookProps = {
  options?: any;
};

const loginProvider = async ({ provider, options }: ProviderProps) => {
  const reqOptions = {
    ...options,
    skipBrowserRedirect: true,
  };
  if (provider === 'google') {
    reqOptions.queryParams = {
      access_type: 'offline',
      prompt: 'consent',
    };
  }
  
  const { data, error } = await supabase.auth.signInWithOAuth({
    provider,
    options: reqOptions,
  });

  if (error) {
    throw new Error(error.message);
  }

    window.location.href = data.url;

  return data;
};

export default function useLoginWithProvider({ options }: HookProps) {
  const queryClient = useQueryClient();

  return useMutation(
    (provider: Provider) => loginProvider({ provider, options }),
    {
      onSuccess: () => {
        queryClient.removeQueries({ queryKey: ['isAuth'] });
        queryClient.removeQueries({ queryKey: ['user'] });
        queryClient.removeQueries({ queryKey: ['profile'] });
        queryClient.removeQueries({ queryKey: ['categories'] });
      },
    },
  );
}
